/**
 * The local storage key `UserPreferencesProvider` persists a preference under.
 *
 * In its own module so the site can read a preference before the provider renders, without
 * importing the provider.
 */
export const getUserPreferencesLocalStorageKey: (preferenceName: string) => string = (
	preferenceName: string,
) => `up.${preferenceName}`;
